import { render, staticRenderFns } from "./PanelSection.vue?vue&type=template&id=5c77adb8&scoped=true&"
import script from "./PanelSection.vue?vue&type=script&lang=js&"
export * from "./PanelSection.vue?vue&type=script&lang=js&"
import style0 from "./PanelSection.vue?vue&type=style&index=0&id=5c77adb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c77adb8",
  null
  
)

export default component.exports